/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsServerNetworkMinus: {
  name: 'server-network-minus';
  data: string;
} = {
  name: 'server-network-minus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4Zm12 0H7v10h10V4Zm-7 4a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2h-4ZM3 20a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H3Zm9-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
